import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import Menu from './components/menu';
import Footer from './components/footer';

import { BrowserRouter, useLocation } from "react-router-dom";
import { AuthProvider } from './contexts/AuthContext';
// New package chatbot
import { Chatbot } from '@veeyaainnovatives/chatbot';
// Import Veeyaa chatbot CSS (only needed for Veeyaa provider)
import '@veeyaainnovatives/chatbot/styles.css';

// Component to conditionally render Menu and Footer
const LayoutWrapper = () => {
  const location = useLocation();
  const isCustomerPage = location.pathname.startsWith('/customer');

  return (
    <>
      {!isCustomerPage && <Menu />}
      <App />
      {!isCustomerPage && <Footer />}
      
        <Chatbot 
          provider="tawk"
          tawkPropertyId="69401d325921b4197ee500f1"
          tawkWidgetId="1jch7cecr"
          hideOnRoutes={['/customer']}
          enableErrorHandling={true}
          enableTitleProtection={true}
        />
      
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
          <BrowserRouter>
      <AuthProvider>
        <LayoutWrapper />
      </AuthProvider>
          </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
